import React from 'react'
import YearSelector from './YearSelector'
import { useState } from 'react'


export const InfoPqr2 = ({ onInputChange, formState }) => {

    const [hoja, setHoja] = useState(true)
    console.log(hoja)


    const hojaSi = () => {
        if (hoja == false) return
        setHoja(true);
        console.log(hoja);
    }

    const hojaNo = () => {
        if (hoja == true) return
        setHoja(false);
        console.log(hoja);
    }

    const handleLineaChange = (event) => {
        let newValue = event.target.value;
        newValue = newValue.replace(/[^a-zA-Z0-9]/g, '').slice(0, 30);
        onInputChange({
            target: {
                name: 'linea',
                value: newValue,
            },
        });
    };

    const handlePlacaChange = (event) => {
        let newValue = event.target.value;
        newValue = newValue.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10);
        onInputChange({
            target: {
                name: 'placa',
                value: newValue,
            },
        });
    };

    return (
        <div className="contenedorInfo">

            {/* TITULO */}

            <div className="contenedorTitulo">
                <h1>
                    INFORMACION DE VEHICULO
                </h1>

            </div>

            {/* PREGUNTA */}

            <div className="contenedorPregunta">
                <p>
                    ¿Cuenta con un Vehículo Adquirido con Nosotros?
                </p>
            </div>

            {/* OPCIONES DE SELECCION */}

            <div className="contenedorRadio">
                <label For="Si"> Si </label>

                <input type="radio" id="Si" name="vehAdquirido" value={true} onClick={hojaSi} onChange={onInputChange} checked={formState.vehAdquirido == "true"} />

                <label For="No"> No </label>

                <input type="radio" id="No" name="vehAdquirido" value={false} onClick={hojaNo} onChange={onInputChange} checked={formState.vehAdquirido == "false"} />


            </div>

            {
                formState.vehAdquirido == "true" &&
                <div className="contenedorFormulario">

                    <div className="contIzquierda">
                        {/* CIUDAD VEHICULO */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="ciudadveh"> Ciudad </label>
                                </div>
                            </div>
                            <div className="contRespuesta">

                                <div className="contIcono">
                                    <i className="iconoCiudad"></i>
                                </div>
                                <div className="contSelect">
                                    <select
                                        name='ciudadveh'
                                        value={formState.ciudadveh}
                                        onChange={onInputChange}
                                        id="idCiudadveh"
                                        className="selectform"
                                        required
                                        tabIndex={1}
                                    >
                                        <option value="" selected disabled>Seleccione la ciudad</option>
                                        <option value="Bogota">Bogotá</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* MARCA */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="marca"> Marca </label>
                                </div>
                            </div>
                            <div className="contRespuesta">

                                <div className="contIcono">
                                    <i className="iconoMarca"></i>
                                </div>
                                <div className="contSelect">
                                    <select
                                        name='marca'
                                        value={formState.marca}
                                        onChange={onInputChange}
                                        id="idMarca"
                                        className="selectform"
                                        tabIndex={3}
                                        required
                                    >
                                        <option value="" selected disabled>Seleccione la marca</option>
                                        <option value="Sinotruk">Sinotruk</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* MODELO */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="modelo"> Modelo </label>
                                </div>
                            </div>
                            <div className="contRespuesta1">

                                <div className="contIcono1">
                                    <i className="iconoModelo"></i>
                                </div>
                                <div className="contText">
                                    <div className="dateform">
                                        <YearSelector onInputChange={onInputChange} formState={formState} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="contDerecha">

                        {/* SEDE */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="sede"> Sede </label>
                                </div>
                            </div>
                            <div className="contRespuesta">

                                <div className="contIcono">
                                    <i className="iconoSede"></i>
                                </div>
                                <div className="contSelect">
                                    <select
                                        name='sede'
                                        value={formState.sede}
                                        onChange={onInputChange}
                                        id="idSede"
                                        className="selectform"
                                        tabIndex={2}
                                        required
                                    >
                                        <option value="" selected disabled >Seleccione la sede</option>
                                        <option value="Fontibon">Sede Fontibón</option>
                                        <option value="Calle 80">Sede Calle 80</option>

                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* LINEA */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="linea"> Línea </label>
                                </div>
                            </div>
                            <div className="contRespuesta1">

                                <div className="contIcono1">
                                    <i className="iconoLinea"></i>
                                </div>
                                <div className="contSelect">

                                    <select
                                        name='linea'
                                        value={formState.linea}
                                        onChange={onInputChange}
                                        className="selectform"
                                        tabIndex={4}
                                        required
                                    >
                                        <option value="" selected disabled >Seleccione la línea del vehículo</option>
                                        <option value="HOWO NQS 9.9 Ton">HOWO NQS 9.9 Ton</option>
                                        <option value="HOWO FRS 10.4 Ton Súper Turbo">HOWO FRS 10.4 Ton Súper Turbo</option>
                                        <option value="HOWO TX 250 4x2 PBV 17.000 Chasís
">HOWO TX 250 4x2 PBV 17.000 Chasís
                                        </option>
                                        <option value="HOWO TX 350 4x2 Minimula">HOWO TX 350 4x2 Minimula</option>
                                        <option value="HOWO TX 400 4x2 Súper Minimula">HOWO TX 400 4x2 Súper Minimula</option>
                                        <option value="HOWO G7 540 Tracto AMT">HOWO G7 540 Tracto AMT</option>
                                        <option value="VOLQUETAS">VOLQUETAS</option>
                                        <option value="MIXER">MIXER</option>
                                    </select>

                                </div>
                            </div>
                        </div>

                        {/* PLACA */}

                        <div className="contTipoid">
                            <div className="contPregunta">
                                <div className="labelform">
                                    <label For="placa"> Placa </label>
                                </div>
                            </div>
                            <div className="contRespuesta1">

                                <div className="contIcono1">
                                    <i className="iconoPlaca"></i>
                                </div>
                                <div className="contText">
                                    <div className="textform" required>
                                        <input
                                            name='placa'
                                            value={formState.placa}
                                            onChange={handlePlacaChange}
                                            className="textformdet"
                                            type="text"
                                            placeholder="Digite la placa del vehículo"
                                            required
                                            tabIndex={6}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>



                </div>

            }

            {
                formState.vehAdquirido == "false" &&
                <div>
                    <br />
                    <br />
                </div>

            }

            <br />

        </div>

    )
}
